import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_STATUS } from "../../constants";
import { useEffect, useState } from "react";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { UpdateArtProfile } from "../../apis/user/update_artist_profile";

export default function EditArtistProfile({ userData, setEdit, setReload }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [ApiStatus, setApiStatus] = useState(API_STATUS);

    const SignupSchema = Yup.object().shape({
        first_name: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Enter first name'),
        last_name: Yup.string()
            .max(50, 'Too Long!')
            .required('Enter last name'),
        mobile: Yup.string()
            .matches(/^[6-9]\d{9}$/, { message: "Enter valid number.", excludeEmptyString: false })
            .required('Enter mobile number'),
        email: Yup.string().email('Invalid email').required('Email id is required'),
        age: Yup.string().required('Enter your age'),
        lng: Yup.string().required('Enter language known'),
        city: Yup.string().required('Enter your city')
    });

    useEffect(() => {
        if (!ApiStatus.isError && !ApiStatus.isLoader) {
            if (ApiStatus.data != null) {
                const res = ApiStatus.data;
                setEdit(false);
                setReload(true);
            }
        }

    }, [ApiStatus]);

    return <div class="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">


        <div className="uk-active" style={{ position: 'relative' }}>
            <div className="bg-white md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        first_name: userData['firstName'],
                        last_name: userData['lastName'],
                        email: userData['email'],
                        mobile: userData['mobile'],
                        age: userData['age'],
                        city: userData['city'],
                        lng: userData['lng'],
                        height: userData['height'],
                        body_vit: userData['body'],
                        work_exp: userData['workExp'],
                        add_info: userData['info'],
                        video_link: userData['video']
                    }}
                    validationSchema={SignupSchema}
                    onSubmit={values => {
                        let body = values;
                        UpdateArtProfile(body, setApiStatus);
                    }}
                >
                    {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                        <div className="space-y-6">
                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> First Name </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="first_name" className="lg:w-1 w-full" />
                                </div>
                            </div>
                            {
                                errors.first_name && touched.first_name &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.first_name}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Last Name </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="last_name" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.last_name && touched.last_name &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.last_name}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Mobile Number </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="mobile" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.mobile && touched.mobile &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.mobile}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Email id </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="email" name="email" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.email && touched.email &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.email}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> City </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="city" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.city && touched.city &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.city}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Age </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="age" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.age && touched.age &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.age}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Languages known </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="lng" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.lng && touched.lng &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.lng}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Height (optional) </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="height" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.height && touched.height &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.height}</div>
                            }

                            <div className="md:flex items-center gap-10">
                                <label className="md:w-32 text-right"> Body Vitals (optional) </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field type="text" name="body_vit" placeholder="CHEST/WAIST/HIPS" className="lg:w-1 w-full" />
                                </div>
                            </div>

                            {
                                errors.body_vit && touched.body_vit &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.body_vit}</div>
                            }

                            <div className="md:flex items-start gap-10">
                                <label className="md:w-32 text-right"> Work experience </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field as="textarea" name="work_exp" placeholder="Leave blank if fresher" className="w-full" rows="5"></Field>
                                </div>
                            </div>
                            {
                                errors.work_exp && touched.work_exp &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.work_exp}</div>
                            }

                            <div className="md:flex items-start gap-10">
                                <label className="md:w-32 text-right"> Additional Information </label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field as="textarea" name="add_info" className="w-full" rows="5"></Field>
                                </div>
                            </div>
                            {
                                errors.add_info && touched.add_info &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.add_info}</div>
                            }

                            <div className="md:flex items-start gap-10">
                                <label className="md:w-32 text-right"> Video Links (Embed video links line by line)</label>
                                <div className="flex-1 max-md:mt-4">
                                    <Field as="textarea" name="video_link" placeholder="Youtube links line by line" className="w-full" rows="5"></Field>
                                </div>
                            </div>
                            {
                                errors.video_link && touched.video_link &&
                                <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.video_link}</div>
                            }

                            <div className="flex items-center justify-center gap-4 mt-16">
                                <button
                                    onClick={() => {
                                        setEdit(false);
                                    }}
                                    type="button" className="button lg:px-6 bg-secondery max-md:flex-1"> Cancle</button>
                                <button
                                    onClick={() => {
                                        if (!isValid) {
                                            setFieldTouched('first_name');
                                            setFieldTouched('last_name');
                                            setFieldTouched('age');
                                            setFieldTouched('email');
                                            setFieldTouched('mobile');
                                            setFieldTouched('lng');
                                            setFieldTouched('city');
                                            setFieldTouched('work_exp');
                                            setFieldTouched('body_vit');
                                            setFieldTouched('add_info');
                                            setFieldTouched('video_link');
                                        } else {
                                            handleSubmit();
                                        }
                                    }}
                                    type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Submite <span className="ripple-overlay"></span></button>
                            </div>
                        </div>
                    )}
                </Formik>
            </div>
            {
                ApiStatus.isLoader &&
                <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center' }}>
                    <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                    <span class="sr-only">Loading...</span>
                </div>
            }
        </div>

    </div>;

}